<div class="unauth-wrapper">
	<div class="unauth-card" role="alert" aria-labelledby="unauth-heading" aria-describedby="unauth-desc">
		<div class="unauth-icon" aria-hidden="true"></div>
		<h1 id="unauth-heading" class="unauth-title">Access Denied</h1>
		<p id="unauth-desc" class="unauth-msg">You are not authorized to view this page or your session may have expired.</p>
		<div class="unauth-actions">
			<button type="button" class="btn-outline" (click)="goHome()">Return to Landing Page</button>
		</div>
	</div>
	<div class="unauth-footer">If you believe this is an error, contact your administrator.</div>
</div>